<template>
  <mdb-container class="mt-5">
    <mdb-card>
      <mdb-card-title class="mt-4 h2">Contact us</mdb-card-title>
      <mdb-card-body>
        <mdb-card-text
          class="pr-5 pl-5"
          mr-4
          ml-4
        >Do you have any questions? Please do not hesitate to contact us directly. Our team will get back to you within a matter of hours to help you.</mdb-card-text>
        <form class="needs-validation" novalidate @submit.prevent="submitForm">
          <mdb-row>
            <mdb-col md="8">
              <mdb-row>
                <mdb-col>
                  <mdb-input label="Your name" v-model="fields.name" required />
                </mdb-col>
                <mdb-col>
                  <mdb-input type="email" label="Your email" v-model="fields.email" required />
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col>
                  <mdb-input label="Subject" v-model="fields.company" required />
                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col>
                  <mdb-input
                    type="textarea"
                    label="Your message"
                    v-model="fields.message"
                    required
                  />
                </mdb-col>
              </mdb-row>
            </mdb-col>
            <mdb-col md="4">
              <mdb-row>
                <mdb-col class="mt-4">

                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col class="mt-4">

                </mdb-col>
              </mdb-row>
              <mdb-row>
                <mdb-col class="mt-4">
                  <mdb-icon icon="envelope" size="2x" />
                  <p>support@personalsigner.com</p>
                </mdb-col>
              </mdb-row>
            </mdb-col>
          </mdb-row>
          <mdb-btn color="primary" type="submit" class="float-left">Send</mdb-btn>
        </form>
      </mdb-card-body>
    </mdb-card>


        <mdb-modal :show="show" @close="show = false" success>
      <mdb-modal-header>
        <mdb-modal-title>Contact registered</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body  class="text-center">
        <mdb-icon icon="check" size="4x" class="mb-3 animated rotateIn"/>
        <p>Your request has been registered. We´ll contact you as soon as we can. Thanks</p>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn outline="success" @click="show = false" > Close </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
      <div class="container">
        <div class="placement">
          <mdb-toast-notification  :title="message.title" :message="message.message" :icon="message.icon" :iconColor="message.color" />
        </div>
      </div>
  </mdb-container>
</template>

<script>
  import axios from "axios";
  import {       mdbToastNotification, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter } from 'mdbvue';

  import {
    mdbContainer,
    mdbInput,
    mdbCard, 
    mdbCardTitle,
    mdbCardText,
    mdbCardBody,
    mdbIcon,
    mdbBtn,
    mdbRow,
    mdbCol
  } from "mdbvue";
  

  export default {
        name: "ContactForm",


    components: {
            mdbToastNotification,
      mdbContainer,
      mdbInput,
      mdbCard,
      mdbCardTitle,
      mdbCardBody,
      mdbCardText,
      mdbIcon,
      mdbBtn,
      mdbRow,
      mdbCol,
       mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter     
    },
    data() {
      return {
        fields: {
          name: "",
          email: "",
          subject: "",
          message: ""
        },
                show: false,
        message:           {
            id: 1,
            title: "Message sent",
            message: "Your request has been registered. We´ll contact you as soon as we can. Thanks",
            icon: 'exclamation',
            color: 'danger'
          },
      };
    },
  beforeCreate() {
    this.show=false;
  },    
  methods: {
      validate() {
        const form = [...arguments];
        const emailRegexp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        for (let index in form) {
          let field = form[index];
          if (field === "email" && !emailRegexp.test(this.fields[field])) {
            return false;
          } else if (this.fields[field] === "") {
            return false;
          }
        }
        return true;
      },
      submitForm(event) {
        event.target.classList.add("was-validated");
        if (this.validate("email", "name", "message", "company")) {
        var contact = {
          name: this.name,
          email: this.email,
          company: this.subject,
          message: this.message
        };

          axios
            .post("https://us-central1-globalservices-189612.cloudfunctions.net/emailMessageFyahpp", this.fields)
            .then(response => {
              this.show = true; 
              this.fields = {};
              event.target.classList.remove("was-validated");
            })
            .catch(error => {
              console.log(error); 
            });





        }
      }
    }
  };
</script>

<style scoped>
  .container {
    text-align: center;
  }
    .container {
    position: relative;
    min-height: 340px;
  }
  .placement {
    position: absolute;
    right: 0;
  }
</style>